import React, {InputHTMLAttributes, useState} from 'react';

import {ReactComponent as CrossIcon} from 'assets/svg/cross.svg';
import {ReactComponent as DownloadIcon} from 'assets/svg/download.svg';

import {NativeInput, Root, Label, FileName, LoadedWrapper, CloseFileIcon} from './styled';
import {InputVariant} from './types';

export interface InputFileProps extends InputHTMLAttributes<HTMLInputElement> {
    variant?: InputVariant;
    className?: string;
    initialValue?: string;
    label?: string;
}

export const InputFile = ({
    className,
    variant = InputVariant.Normal,
    onChange,
    initialValue,
    label,
    ...otherProps
}: InputFileProps) => {
    const [value, setValue] = useState<string | null>(initialValue || null);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const inputValue = (e?.target as HTMLInputElement).value.split(/(\\|\/)/g).pop();
        onChange && onChange(e);
        inputValue && setValue(inputValue);
    };
    const handleBtnClick = (evt: any) => {
        evt.preventDefault();
        onChange && onChange(evt);
        setValue(null);
    };

    return (
        <Root className={className}>
            {!value && (
                <Label variant={variant}>
                    <DownloadIcon style={{width: 15, height: 15, marginRight: 10}} />
                    {label || 'Загрузить файл'}
                    <NativeInput {...otherProps} onChange={handleChange} />
                </Label>
            )}

            {value && (
                <LoadedWrapper>
                    <FileName>{value}</FileName>
                    <CloseFileIcon
                        source={CrossIcon}
                        width={12}
                        height={12}
                        onClick={handleBtnClick}
                    />
                </LoadedWrapper>
            )}
        </Root>
    );
};

export {InputVariant};
